module.exports = __webpack_public_path__ + "static/media/pic.88ab3be5.png";